import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users, Target, Eye, Award } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AboutUs = () => {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    try {
      const response = await axios.get(`${API}/team`);
      setTeam(response.data);
    } catch (error) {
    }
  };

  return (
    <div data-testid="about-page">
      <section
        className="relative min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1758518731468-98e90ffd7430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwY29ycG9yYXRlJTIwdGVhbSUyMG1lZXRpbmclMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMTMxNTY4fDA&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-stone-900/60" />
        <div className="relative z-10 text-center px-6 text-white">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold tracking-tight mb-4">
            About DBK Group Of Companies
          </h1>
          <p className="text-xl text-stone-200">Building Excellence Since 2009</p>
          <div className="mt-10 animate-bounce">
            <svg className="w-8 h-8 mx-auto text-stone-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12 max-w-7xl mx-auto" data-testid="company-story">
        <div className="max-w-4xl mx-auto">
          <p className="text-stone-600 uppercase tracking-widest text-xs mb-4">OUR BUSINESSES</p>
          <h2 className="text-4xl font-playfair font-bold text-stone-900 mb-8 tracking-tight">
            Our Group Of Companies
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 bg-stone-50 border-l-4 border-emerald-900">
              <h3 className="text-xl font-bold text-stone-900 mb-2">1. Ashtavinayak Poultry Farm</h3>
              <p className="text-stone-600">Leading poultry farm operations with commitment to quality and sustainability.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-amber-600">
              <h3 className="text-xl font-bold text-stone-900 mb-2">2. Dream Kokan City</h3>
              <p className="text-stone-600">Premier plotting project in the scenic Kokan region.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-emerald-900">
              <h3 className="text-xl font-bold text-stone-900 mb-2">3. Dream Nagpur City</h3>
              <p className="text-stone-600">Flagship plotting development in Nagpur district.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-amber-600">
              <h3 className="text-xl font-bold text-stone-900 mb-2">4. Ashtavinayak Infra</h3>
              <p className="text-stone-600">Infrastructure development and construction services.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-emerald-900">
              <h3 className="text-xl font-bold text-stone-900 mb-2">5. Propkart Multitrade India Pvt. Ltd.</h3>
              <p className="text-stone-600">Diversified trading and real estate services.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-amber-600">
              <h3 className="text-xl font-bold text-stone-900 mb-2">6. Siddhivinayak Infra</h3>
              <p className="text-stone-600">Quality infrastructure and development projects.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-emerald-900">
              <h3 className="text-xl font-bold text-stone-900 mb-2">7. Agasti Developers</h3>
              <p className="text-stone-600">Residential and commercial development expertise.</p>
            </div>
            <div className="p-6 bg-stone-50 border-l-4 border-amber-600">
              <h3 className="text-xl font-bold text-stone-900 mb-2">8. Enterglobe Construction Pvt. Ltd.</h3>
              <p className="text-stone-600">Comprehensive construction and project management.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12 bg-stone-100" data-testid="values-section">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center">
            <p className="text-stone-600 uppercase tracking-widest text-xs mb-4">WHAT DRIVES US</p>
            <h2 className="text-4xl sm:text-5xl font-playfair font-bold text-stone-900 tracking-tight">
              Our Core Values
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="p-8 bg-white border-l-2 border-emerald-900">
              <Target className="w-12 h-12 text-emerald-900 mb-4" />
              <h3 className="text-xl font-playfair font-bold text-stone-900 mb-3">Mission</h3>
              <p className="text-stone-600 leading-relaxed">
                To deliver world-class real estate developments that exceed expectations and create lasting value.
              </p>
            </div>
            <div className="p-8 bg-white border-l-2 border-amber-600">
              <Eye className="w-12 h-12 text-amber-600 mb-4" />
              <h3 className="text-xl font-playfair font-bold text-stone-900 mb-3">Vision</h3>
              <p className="text-stone-600 leading-relaxed">
                To be the most trusted name in real estate development, known for innovation and excellence.
              </p>
            </div>
            <div className="p-8 bg-white border-l-2 border-emerald-900">
              <Award className="w-12 h-12 text-emerald-900 mb-4" />
              <h3 className="text-xl font-playfair font-bold text-stone-900 mb-3">Quality</h3>
              <p className="text-stone-600 leading-relaxed">
                We never compromise on quality, ensuring every project meets the highest standards.
              </p>
            </div>
            <div className="p-8 bg-white border-l-2 border-amber-600">
              <Users className="w-12 h-12 text-amber-600 mb-4" />
              <h3 className="text-xl font-playfair font-bold text-stone-900 mb-3">People First</h3>
              <p className="text-stone-600 leading-relaxed">
                Our clients, team, and communities are at the heart of everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 lg:px-12 bg-gradient-to-b from-white to-stone-50" data-testid="team-section">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16 text-center">
            <p className="text-stone-600 uppercase tracking-widest text-xs mb-4">MEET THE EXPERTS</p>
            <h2 className="text-4xl sm:text-5xl font-playfair font-bold text-stone-900 tracking-tight mb-6">
              Our Leadership Team
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto italic">
              "Visionaries shaping skylines, leaders building dreams into reality"
            </p>
          </div>

          <div className={`grid gap-12 ${team.length === 2 ? 'grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'}`}>
            {team.map((member) => (
              <div
                key={member.id}
                data-testid={`team-member-${member.id}`}
                className="group bg-white border border-stone-200 overflow-hidden hover:border-emerald-900 hover:shadow-xl transition-all duration-300"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={member.image_url}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-playfair font-bold text-stone-900 mb-2">{member.name}</h3>
                  <p className="text-amber-600 uppercase tracking-widest text-xs mb-4">{member.position}</p>
                  <p className="text-stone-600 leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>

          {team.length === 0 && (
            <p className="text-center text-stone-500">Team information will be updated soon.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;